import { isColorFormatRgb } from '../../../ColorPicker.utils'
import { getDisplayColorValue } from '../../../ColorPickerField'

import * as styles from '../ColorPickerPopoverPreview.module.css'

function ColorPickerPopoverPreviewValueTrigger({
  color,
  colorFormat,
  rgb,
  onClick,
  onKeyDown,
}) {
  return (
    <div
      className={styles.valueTextTrigger}
      role='button'
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      {isColorFormatRgb(colorFormat) ? (
        <div className={styles.rgbValueBlock}>
          <span className={styles.rgbValue}>{rgb.r}</span>
          <span className={styles.rgbValue}>{rgb.g}</span>
          <span className={styles.rgbValue}>{rgb.b}</span>
        </div>
      ) : (
        <span className={styles.colorValue}>
          {getDisplayColorValue(color, colorFormat)}
        </span>
      )}
    </div>
  )
}

export default ColorPickerPopoverPreviewValueTrigger
